import type { Route } from '@/@types/gtfs-ressource';

/**
 * The routes calling at each stop, or at any stop gathered under it (`stations`:
 * a displayed stop -> the stop_ids carrying its departures), in the network's
 * route order. Built once per network: looking each stop up against every route
 * on each keystroke froze the stops list on a large network.
 */
export function routesByStop(
  routeStops: { [routeId: string]: { [stopId: string]: boolean } },
  routes: { [routeId: string]: Route },
  stations: { [stopId: string]: Array<string> },
): { [stopId: string]: Array<Route> } {
  const displayedStopIdsOf: { [stopId: string]: Array<string> } = {};
  Object.entries(stations).forEach(([displayedStopId, memberIds]) => {
    memberIds.forEach(memberId => (displayedStopIdsOf[memberId] ??= []).push(displayedStopId));
  });

  const stopRoutes: { [stopId: string]: Array<Route> } = {};
  Object.entries(routeStops).forEach(([routeId, servedStops]) => {
    const route = routes[routeId];
    if (!route) return;
    Object.keys(servedStops).forEach(servedStopId => {
      [servedStopId, ...(displayedStopIdsOf[servedStopId] ?? [])].forEach(stopId => {
        const stopRouteList = (stopRoutes[stopId] ??= []);
        if (!stopRouteList.includes(route)) stopRouteList.push(route);
      });
    });
  });
  return stopRoutes;
}
